let state = {
    Cards : [
            {
                id: "UBR-X200",
                href: "https://www.pult.ru/product/4k-blu-ray-pleer-reavon-x200",
                description: "Проигрыватель Reavon UBR-X200 придаст универсальность вашему домашнему кинотеатру, благодаря способности воспроизводить диски Ultra HD Blu-ray, DVD, CD, SACD, DVD-Audio, а также музыкальные файлы высокого разрешения с USB-накопителей и сетевых устройств. Внешне проигрыватель выглядит как устройство премиум-класса — благодаря высокому качеству изготовления и стильному корпусу стандартной ширины с шасси, усиленным стальной пластиной. Восьмиканальный ЦАП Burr-Brown и процессор MediaTek обеспечивают исчерпывающий набор функциональных особенностей, включая симметричные выходы на разъемах XLR для вывода стереозвука и поддержку формата Dolby Vision HDR на современных 4K-телевизорах. Экранное меню обеспечивает полный контроль настроек в соответствии с вашими предпочтениями, а пульт ДУ с подсветкой идеально подходит для использования в домашнем кинозале. UBR-X200 — идеальный выбор для тех, кто любит высококачественный контент на дисках.",
                title: "UBR-X200",
                subtitle: "ФЛАГМАНСКИЙ УНИВЕРСАЛЬНЫЙ ПРОИГРЫВАТЕЛЬ 4K ULTRA HD",
                text: "Наша флагманская модель UBR-X200 предназначена для проигрывания дисков с максимально высоким качеством. Благодаря исключительно жесткой конструкции устройство обеспечивает прекрасное отношение сигнал/шум, необходимое для воспроизведения аудио- и видеоконтента с высоким качеством. Поддержка новейшего формата Ultra HD Blu-ray™ позволяет просматривать фильмы с разрешением, в четыре раза превосходящим стандарт 1080p Full HD. Модель UBR-X200 также совместима с современным форматом Dolby Vision®, в котором реализована поддержка расширенного динамического диапазона (HDR) и широкого цветового пространства с выдающимся уровнем цветопередачи, контрастности и яркости изображения. ЦАПы Burr-Brown Audio PCM1690 компании Texas Instruments обеспечивают истинно аудиофильское звучание. Другие особенности включают режим апскейлинга SDR/HDR, функцию Direct/Transport, совместимость с форматами SACD/DSD, поддержку многоканального аналогового аудиосигнала и симметричные выходы на разъемах XLR.",
                src: "/img/img2.png",
                alt: "UBR-X200",
                desc: "Ваша коллекция фильмов достойна самого лучшего",
                blocks: [
                    {
                        title: "СВЕРХПРОЧНЫЙ КОРПУС СО СТАЛЬНОЙ ПЛАСТИНОЙ В ОСНОВАНИИ",
                        text: "Основание шасси толщиной 1,6 мм усилено жесткой 3-мм стальной пластиной для сведения до минимума механического шума при вращении привода BD. Это позволило обеспечить низкий уровень шумов и жесткую, стабильную конструкцию."
                    },
                    {
                        title: "ИНФОРМАЦИЯ О НОСИТЕЛЕ, ОТОБРАЖАЕМАЯ НА ЭКРАНЕ",
                        text: "Нажав и удерживая кнопку INFO на пульте ДУ, вы можете вывести на экран информацию о диске, установленном в лоток. Кроме того, можно просмотреть данные мастеринга, такие как MaxFALL (Максимальный средний уровень яркости кадра) и MaxCLL (Максимальный уровень яркости контента), которые могут быть встроены в HDR-контент. Также вам будет доступна информация о HDR и выходных параметрах HDMI."
                    },
                    {
                        title: "ТОРОИДАЛЬНЫЙ ТРАНСФОРМАТОР",
                        text: "Питание UBR-X200 реализовано на тороидальном трансформаторе, для которого характерен низкий уровень шума и электромагнитных помех. Во многом это связано с его формой и симметрией. Силовые линии магнитного поля практически не выходят за пределы сердечника и удерживаются внутри замкнутой конструкции. В результате снижаются искажения аудиосигнала, возрастает чистота и точность звучания."
                    },
                    {
                        title: "УНИВЕРСАЛЬНЫЙ ПРОИГРЫВАТЕЛЬ",
                        text: "Являясь универсальным проигрывателем, UBR-X200 воспроизводит оптические диски различного типа, включая новейший формат Ultra HD Blu-ray, который обеспечивает разрешение, в четыре раза превышающее стандарт 1080p Full HD, а также диски Blu-ray, Blu-ray 3D, DVD, CD, SACD, музыкальные, видео- и аудиофайлы, такие как FLAC, AIFF, DFF, DSF, JPG, TIFF, MKV и M2TS. Кроме того, UBR-X200 воспроизводит аудио- и видеоконтент с внешних накопителей с интерфейсом USB или с DLNA-серверов."
                    }
                ],
                img1: "/img/pult 2.png",
                img2: "/img/REAVON-2.png",
                brends: "/img/brends2.png",
                awards: [
                    { award:"/img/award11.png"},
                    { award:"/img/award12.png"},
                    { award:"/img/award13.png"},
                    { award:"/img/award14.png"},
                    { award:"/img/award15.png"},
                    { award:"/img/award16.png"},
                ],
                sectionDescription: [
                    {
                      li: `Логотип REAVON является зарегистрированным товарным знаком Groupe Archisoft и используется по лицензии.`
                    },
                    {
                        li: `Логотип DVD является товарным знаком компании DVD Format/Logo Licensing Corporation.`
                    },
                    {
                        li: `Super Audio CD является товарным знаком.`
                    },
                    {
                        li: `DSD и логотип Direct Stream Digital являются товарными знаками корпорации Sony.`
                    },
                    {
                        li: `«x.v.Color» является товарным знаком корпорации Sony.`
                    },
                    {
                        li: `Названия Dolby, Dolby Surround, Dolby Vision и двойной символ D являются товарными знаками Dolby Laboratories.`
                    },
                    {
                        li: `Патенты DTS представлены на сайте http://patents.dts.com. Произведено по лицензии DTS Licensing Limited. DTS, DTS-HD, соответствующий символ, а также сочетание DTS-HD и соответствующего символа являются зарегистрированными товарными знаками компании DTS, Inc. на территории США и/или других государств.`
                    },
                    {
                        li: `© DTS, Inc. Все права защищены.`
                    },
                    {
                        li: `Изделия с логотипом Hi-Res Audio соответствуют стандарту HiRes Audio, учрежденному Японским обществом записи и воспроизведения звука. Этот логотип используется по лицензии Японского общества записи и воспроизведения звука.`
                    },
                    {
                        li: `Буквенные обозначения Blu-ray Disc™, Blu-ray™, BD-LIVE™, BONUS VIEW™, Ultra HD Blu-ray™ и соответствующие им логотипы являются товарными знаками Blu-ray Disc Association.`
                    },
                    {
                        li: `Логотип ULTRA HD PREMIUM™ является товарным знаком или зарегистрированным товарным знаком UHD Alliance, Inc. на территории США и/или других государств.`
                    },
                    {
                        li: `Все другие товарные знаки и зарегистрированные товарные знаки являются собственностью их владельцев.`
                    }
                ],
                listSpecifications: [
                    [
                        {
                            li: `Универсальный проигрыватель: Ultra HD Blu-ray, Blu-ray, DVD, DVD Audio, CD`
                        },
                        {
                            li: `BD-Live/BONUSVIEW`
                        },
                        {
                            li: `HDR10`
                        },
                        {
                            li: `Dolby Vision` 
                        },
                        {
                            li: `36-битный цвет Deep Colour/”x.v.Colour”`
                        },
                        {
                            li: `Два выхода HDMI`
                        },
                        {
                            li: `Настройка видеоизображения`
                        },
                        {
                            li: `Пульт ДУ с подсветкой`
                        },
                        {
                            li: `Быстрая загрузка`
                        },
                        {
                            li: `Воспроизведение мультимедийного контента (MKV, FLAC, AIFF, MP3, JPG)`
                        }
                    ],
                    [
                        {
                            li: `4K-масштабирование: поднимите уровень своего домашнего кинотеатра благодаря четырехкратному повышению разрешения Full HD 1080p до 4K (3840 x 2160) для любых источников сигнала.`
                        },
                        {
                            li: `24p True Cinema: многие диски Blu-ray и 4K Ultra HD Blu-ray кодируются с частотой 24 кадра в секунду – это как оригинальная пленка, используемая в кинотеатрах. Модель UBR-X200 выводит на экран те же 24 кадра в секунду с прогрессивной разверткой.`
                        },
                        {
                            li: `Dolby Vision®: передовая технология обработки видеоизображения HDR обеспечивает насыщенную контрастность и мягкие цветовые градации.`
                        },
                        {
                            li: `Настройка видеоизображения: функции регулировки яркости, контрастности, насыщенности, цветового тона, резкости и шумоподавления.`
                        }
                    ],
                    [
                        {li: `ЦАПы Burr-Brown Audio PCM1690 компании Texas Instruments`},
                        {li: `Тороидальный трансформатор большой мощности на печатной плате (класс военной техники)`},
                        {li: `Конденсаторы аудиофильского уровня, изготовленные по особому заказу`},
                        {li: `Функция Direct для чисто аналогового вывода аудиосигнала`},
                        {li: `Два выхода HDMI для чисто цифрового вывода аудиосигнала`},
                        {li: `Генератор тактовых импульсов без джиттера`},
                        {li: `Сверхпрочная конструкция корпуса`},
                        {li: `3-мм стальная пластина в основании шасси проигрывателя смещает центр тяжести вниз для снижения шумов`},
                        {li: `Высококачественная основная плата для улучшения отношения сигнал/шум`},
                        {li: `Привод оптических дисков с жестким креплением`},
                        {li: `24-битный ЦАП Delta-Sigma`},
                        {li: `8-канальный ЦАП:Коммутация:•Выход HDMI 1 для аудио- и видеосигнала`},
                        {li: `Выход HDMI 2 только для аудиосигнала`},
                        {li: `Цифровой коаксиальный выход`},
                        {li: `Цифровой оптический выход`},
                        {li: `Порты USB (1 х USB 2.0 на передней панели, 1 х USB 3.0 на задней панели)`},
                        {li: `Порт Ethernet`},
                        {li: `Интерфейс RS-232C`},
                        {li: `Аналоговые стереовыходы (несимметричные RCA, симметричные XLR)`},
                        {li: `Аналоговые многоканальные выходы: конфигурация 7.1/5.1Технические характеристики:•Процессор Mediatek MTK8581`},
                        {li: `4-ядерный кластер ARM Cortex-A53`},
                        {li: `Графический процессор ARM Mali-T860 MP2Общие характеристики:•Питание: 220–240 В переменного тока, частота 50/60 Гц`},
                        {li: `Потребляемая мощность: 42 Вт`},
                        {li: `Потребляемая мощность в режиме ожидания: 0,45 Вт`},
                        {li: `Габариты (ШхВхГ): 430 х 82 х 351 мм`},
                        {li: `Масса: 6,8 кг (15 фунтов)•Высокая производительность: дифференциальная конструкция, fS = 48 кГц`},
                        {li: `КНИ+шум: –94 дБ`},
                        {li: `Отношение сигнал/шум: 113 дБ`},
                        {li: `Динамический диапазон: 113 дБ`},
                        {li: `Частота дискретизации: 8-192 кГц`},
                        {li: `Тактовая частота: 128 fS, 192 fS, 256 fS, 384 fS, 512 fS, 768 fS, 1152 fS`},
                        {li: `Дифференциальное выходное напряжение: 8 VPP`},
                        {li: `Аналоговый фильтр пропускания низких частот`},
                        {li: `Цифровой фильтр с 4- и 8-кратной передискретизацией:`},
                        {li: `Неравномерность в полосе пропускания: ±0,0018 дБ`},
                        {li: `Ослабление полосы задерживания: –75 дБ•Флаг нуля`},
                        {li: `Длина данных: 16, 20, 24, 32 бит`},
                        {li: `Отключение аналогового сигнала при обнаружении остановки клока`},
                        {li: `Поддерживаемые форматы аудиофайлов: FLAC (2.0/5.1), M4A, AIF, AIFF, DSF (2.0/5.1), DFF (2.0/5.1), MP3, OGG, APE`},
                        {li: `Поддерживаемые форматы аудиосигнала в домашнем кинотеатре: Dolby Digital, Dolby Digital Plus, Dolby TrueHD, Dolby Atmos, DTS, DTS-HD MA, DTS-HD HRA, DTS:X`},
                    ],
                    [
                        {
                            li: `Выход HDMI 1 для аудио- и видеосигнала`
                        },
                        {
                            li: `Выход HDMI 2 только для аудиосигнала`
                        },
                        {
                            li: `Цифровой коаксиальный выход`,
                        },
                        {
                            li: `Цифровой оптический выход`,
                        },
                        {
                            li: `Порты USB (1 х USB 2.0 на передней панели, 1 х USB 3.0 на задней панели)`
                        },
                        {
                            li: `Порт Ethernet`
                        },
                        {
                            li: `Интерфейс RS-232C`
                        },
                        {
                            li: `Аналоговые стереовыходы (несимметричные RCA, симметричные XLR)`
                        },
                        {
                            li: `Аналоговые многоканальные выходы: конфигурация 7.1/5.1`
                        }
                    ],
                    [
                        {
                            li: `Процессор Mediatek MTK8581`,
                        },
                        {
                            li: `4-ядерный кластер ARM Cortex-A53`,
                        },
                        {
                            li: `Графический процессор ARM Mali-T860 MP2`
                        }
                    ],
                    [
                        {
                            li: `Питание: 220–240 В переменного тока, частота 50/60 Гц`,
                        },
                        {
                            li: `Потребляемая мощность: 42 Вт`,
                        },
                        {
                            li: `Потребляемая мощность в режиме ожидания: 0,45 Вт`,
                        },
                        {
                            li: `Габариты (ШхВхГ): 430 х 82 х 351 мм`,
                        },
                        {
                            li: `Масса: 6,8 кг (15 фунтов)`,
                        }
                    ]

                ]
                
            },
            {
                id: "UBR-X100",
                href: "https://www.pult.ru/product/4k-blu-ray-pleer-reavon-x100",
                title: "UBR-X100",
                subtitle: "УНИВЕРСАЛЬНЫЙ ПРОИГРЫВАТЕЛЬ 4K ULTRA HD",
                text: "Модель UBR-X100 предназначена для проигрывания дисков с максимально высоким качеством. Благодаря исключительно жесткой конструкции устройство обеспечивает прекрасное отношение сигнал/шум, необходимое для воспроизведения аудио- и видеоконтента с высоким качеством. Поддержка новейшего формата Ultra HD Blu-ray™ позволяет просматривать фильмы с разрешением, в четыре раза превосходящим стандарт 1080p Full HD. Модель UBR-X200 также совместима с современным форматом Dolby Vision®, в котором реализована поддержка расширенного динамического диапазона (HDR) и широкого цветового пространства с выдающимся уровнем цветопередачи, контрастности и яркости изображения. Среди других особенностей — режим апскейлинга SDR/HDR и два выхода HDMI.",
                src: "/img/img1.png",
                alt: "UBR-X100",
                desc: "Максимум впечатлений от домашнего кинотеатра",
                blocks: [
                    {
                        title: "СВЕРХПРОЧНЫЙ КОРПУС СО СТАЛЬНОЙ НИЖНЕЙ ПАНЕЛЬЮ",
                        text: "Основание шасси толщиной 1,6 мм усилено жесткой 3-мм стальной пластиной для сведения до минимума механического шума при вращении привода BD. Это позволило обеспечить низкий уровень шумов и жесткую, стабильную конструкцию."
                    },
                    {
                        title: "УНИВЕРСАЛЬНЫЙ ПРОИГРЫВАТЕЛЬ",
                        text: "Являясь универсальным проигрывателем, UBR-X100 воспроизводит оптические диски различного типа, включая новейший формат Ultra HD Blu-ray, который обеспечивает разрешение, в четыре раза превышающее стандарт 1080p Full HD. Также он воспроизводит Blu-ray, Blu-ray 3D, DVD, DVD Audio, CD; музыкальные, видео- и аудиофайлы такие, как FLAC, AIFF, DFF, DSF, JPG, TIFF, MKV, M2TS. Кроме того, UBR-X100 воспроизводит аудио- и видеоконтент с внешних накопителей с интерфейсом USB или с DLNA-серверов."
                    },
                    {
                        title: "ИНФОРМАЦИЯ О НОСИТЕЛЕ, ОТОБРАЖАЕМАЯ НА ЭКРАНЕ",
                        text: "Нажав и удерживая кнопку INFO на пульте ДУ, вы можете вывести на экран информацию о диске, установленном в лоток. Кроме того, можно просмотреть данные мастеринга, такие как MaxFALL (Максимальный средний уровень яркости кадра) и MaxCLL (Максимальный уровень яркости контента), которые могут быть встроены в HDR-контент. Также вам будет доступна информация о HDR и выходных параметрах HDMI."
                    }
                ],
                img1: "/img/pult 1.png",
                img2: "/img/REAVON-100.png",
                brends: "/img/brends1.png",
                awards: [
                    { award:"/img/award21.png"},
                    { award:"/img/award22.png"},
                ],
                sectionDescription: [
                    {
                        li: `Логотип REAVON является зарегистрированным товарным знаком Groupe Archisoft и используется по лицензии.`
                    },
                    {
                        li: `Логотип DVD является товарным знаком компании DVD Format/Logo Licensing Corporation.`
                    },
                    {
                        li: `Super Audio CD является товарным знаком.`
                    },
                    {
                        li: `DSD и логотип Direct Stream Digital являются товарными знаками корпорации Sony.`
                    },
                    {
                        li: `«x.v.Color» является товарным знаком корпорации Sony.`
                    },
                    {
                        li: `Названия Dolby, Dolby Surround, Dolby Vision и двойной символ D являются товарными знаками Dolby Laboratories.`
                    },
                    {
                        li: `Патенты DTS представлены на сайте http://patents.dts.com. Произведено по лицензии DTS Licensing Limited. DTS, DTS-HD, соответствующий символ, а также сочетание DTS-HD и соответствующего символа являются зарегистрированными товарными знаками компании DTS, Inc. на территории США и/или других государств.`
                    },
                    {
                        li: `© DTS, Inc. Все права защищены.`
                    },
                    {
                        li: `Изделия с логотипом Hi-Res Audio соответствуют стандарту HiRes Audio, учрежденному Японским обществом записи и воспроизведения звука. Этот логотип используется по лицензии Японского общества записи и воспроизведения звука.`
                    },
                    {
                        li: `Буквенные обозначения Blu-ray Disc™, Blu-ray™, BD-LIVE™, BONUS VIEW™, Ultra HD Blu-ray™ и соответствующие им логотипы являются товарными знаками Blu-ray Disc Association.`
                    },
                    {
                        li: `Логотип ULTRA HD PREMIUM™ является товарным знаком или зарегистрированным товарным знаком UHD Alliance, Inc. на территории США и/или других государств.`
                    },
                    {
                        li: `Все другие товарные знаки и зарегистрированные товарные знаки являются собственностью их владельцев.`
                    }
                ],
                listSpecifications: [
                    [
                        {
                            li: `Универсальный проигрыватель: Ultra HD Blu-ray, Blu-ray, DVD, DVD Audio, CD`
                        },
                        {
                            li: `BD-Live/BONUSVIEW`
                        },
                        {
                            li: `HDR10`
                        },
                        {
                            li: `Dolby Vision` 
                        },
                        {
                            li: `36-битный цвет Deep Colour/”x.v.Colour”`
                        },
                        {
                            li: `Два выхода HDMI`
                        },
                        {
                            li: `Настройка видеоизображения`
                        },
                        {
                            li: `Пульт ДУ с подсветкой`
                        },
                        {
                            li: `Быстрая загрузка`
                        },
                        {
                            li: `Воспроизведение мультимедийного контента (MKV, FLAC, AIFF, MP3, JPG)`
                        }
                    ],
                    [
                        {
                            li: `4K-масштабирование: поднимите уровень своего домашнего кинотеатра благодаря четырехкратному повышению разрешения Full HD 1080p до 4K (3840 x 2160) для любых источников сигнала.`
                        },
                        {
                            li: `24p True Cinema: многие диски Blu-ray и 4K Ultra HD Blu-ray кодируются с частотой 24 кадра в секунду – это как оригинальная пленка, используемая в кинотеатрах. Модель UBR-X200 выводит на экран те же 24 кадра в секунду с прогрессивной разверткой.`
                        },
                        {
                            li: `Dolby Vision®: передовая технология обработки видеоизображения HDR обеспечивает насыщенную контрастность и мягкие цветовые градации.`
                        },
                        {
                            li: `Настройка видеоизображения: функции регулировки яркости, контрастности, насыщенности, цветового тона, резкости и шумоподавления.`
                        }
                    ],
                    [
                        {
                            li: `Аудиовыход HDMI обеспечивает вывод цифрового аудиосигнала с максимально высоким качеством`
                        },
                        {
                            li: `Сверхпрочная конструкция корпуса`,
                        },
                        {
                            li: `3-мм стальная пластина в основании шасси проигрывателя смещает центр тяжести вниз для снижения шумов`
                        },
                        {
                            li: `Привод оптических дисков с жестким креплением`
                        },
                        {
                            li: `Поддерживаемые форматы аудиофайлов: FLAC (2.0/5.1), M4A, AIF, AIFF, DSF (2.0/5.1), DFF (2.0/5.1), MP3, OGG, APE` 
                        },
                        {
                            li: `Поддерживаемые форматы аудиосигнала в домашнем кинотеатре: Dolby Digital, Dolby Digital Plus, Dolby TrueHD, Dolby Atmos, DTS, DTS-HD MA, DTS-HD HRA, DTS:X`
                        }
                    ],
                    [
                        {
                            li: `Выход HDMI 1 для аудио- и видеосигнала`
                        },
                        {
                            li: `Выход HDMI 2 только для аудиосигнала`
                        },
                        {
                            li: `Цифровой коаксиальный выход`,
                        },
                        {
                            li: `Цифровой оптический выход`,
                        },
                        {
                            li: `Порты USB (1 х USB 2.0 на передней панели, 1 х USB 3.0 на задней панели)`
                        },
                        {
                            li: `Порт Ethernet`
                        }
                    ],
                    [
                        {
                            li: `Процессор Mediatek MTK8581`,
                        },
                        {
                            li: `4-ядерный кластер ARM Cortex-A53`,
                        },
                        {
                            li: `Графический процессор ARM Mali-T860 MP2`
                        }
                    ],
                    [
                        {
                            li: `Питание: 220–240 В переменного тока, частота 50/60 Гц`,
                        },
                        {
                            li: `Потребляемая мощность: 32 Вт`,
                        },
                        {
                            li: `Потребляемая мощность в режиме ожидания: 0,45 Вт`,
                        },
                        {
                            li: `Габариты (ШхВхГ): 430 х 82 х 351 мм`,
                        },
                        {
                            li: `Масса: 6,3 кг (13,9 фунтов)`,
                        }
                    ]
                ]
            }
    ],
    FooterList : [
        [
            {   id: "2item",
                idCol: "2Col",
                title: "Каталог",
                href: "https://www.pult.ru/main/akustika",
                text: "Акустика"
            },
            {
                href: "https://www.pult.ru/main/hi-fi/",
                text: "Hi-Fi"
            },
            {
                href: "https://www.pult.ru/main/vinil/",
                text: "Винил"
            },
            {
                href: "https://www.pult.ru/main/naushniki/",
                text: "Наушники"
            },
            {
                href: "https://www.pult.ru/main/televizory/",
                text: "Телевизоры"
            },
            {
                href: "https://www.pult.ru/main/proektory/",
                text: "Проекторы"
            }
        ],
        [
            {   id: "1item",
                idCol: "1Col",
                title: "PULT.RU",
                href: "https://www.pult.ru/main/akustika",
                text: "О компании"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Контакты"
            },
            {
                href: "https://www.pult.ru/contacts/",
                text: "Салоны"
            },
            {
                href: "https://www.pult.ru/news/",
                text: "Новости"
            },
            {
                href: "https://www.pult.ru/articles/",
                text: "Обзоры и статьи"
            }
        ],
    ]
}
export default state;